import React from 'react'
import styled from 'styled-components'
import inforPicture from '../../asset/desktop/Information.png'
import info from '../../asset/desktop/info.png'
import Line from '../../asset/desktop/line.png'

const Index = ({title, textShadow, headerImg}) => {
    return (
        <Information>
            <section className = 'flex flex-col sm:flex-row sm:justify-between sm:items-center pl-4 sm:pl-14 mt-10 sm:mt-0'>
                <div className = 'info'>
                    <img src = {textShadow} alt = 'info' />
                    <div>
                        <img src = {Line} />
                        <p>{title}</p>
                    </div>
                </div>

                <div>
                    <img src = {headerImg} alt = 'info' />
                </div>
            </section>
        </Information>
    )
}

const Information = styled.div`
    .info {
        position: relative;

        div {
            position: absolute;
            top: 0;
            color: #161F6D;
            font-size: 3.265rem;
            font-family: "GreyCliff-Bold", sans-serif;
        }
    }

    @media screen and (max-width: 650px) {

    }

`

export default Index
